import { useEffect, useState } from 'react';

const TIMEOUT = 500;

export const useDebounce = <T>(inbound: T, delay = TIMEOUT) => {
  const [value, setValue] = useState<T>(inbound);

  useEffect(() => {
    const handler = setTimeout(() => {
      setValue(inbound);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [inbound, delay]);

  return value;
};
